<template>
  <div
    :class="{ profileMembres: true, selected: selected, deleteMode: deleteMode }"
    :idProfile="result.profile.id"
    @click="clicked"
    @touchstart="down"
  >
    <div class="rondCadrePhoto image">
      <Photo :profile="result.profile" :pic="result.profile.mainPicture" thumb />
    </div>
    <div class="info">
      <div class="pseudoMessagerieProfileBox">
        <ConnectedIcon :profile="result.profile" />
        <Pseudo class="pseudo" :profile="result.profile">, {{ result.profile.age }} ans </Pseudo>
      </div>
    </div>

    <div class="notif">
      <transition name="fade" mode="out-in">
        <template>
          <span key="unread" v-if="!typing && unread"><img class="unread" :src="receivedLetter"/></span>
          <span key="typing" v-if="typing">
            <img :src="'/assets/icons_' + $store.state.iconTheme + '/edit.png'" />
          </span>
        </template>
      </transition>
    </div>
    <a v-on:click.prevent="pointsClicked" class="petitBouton fermer">
      ...
      <div class="menuPoints" v-if="subMenu">
        <a @click="deleteClicked"><ThemedIcon name="cross2.png" />Supprimer la conversation</a>
        <a @click="block"><ThemedIcon name="blacklist.png" />Bloquer ce profil</a>
        <a @click="warn"><ThemedIcon name="warning.png" />Signaler ce profil</a>
        <a @click="closeSubMenu">Fermer</a>
      </div>
    </a>
  </div>
</template>

<script>
import ConnectedIcon from "@/components/profile/ConnectedIcon";
import Photo from "@/components/profile/Photo";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { idyuFormatDate } from "@/assets/js/idyu/util.js";
import { ScrollableList } from "@/assets/js/scrollableList.js";
import BaseProfileBox from "@/components/util/BaseProfileBox";
import Pseudo from "@/components/profile/Pseudo";
import { ellapsed } from "@/assets/js/idyu/util.js";
import ThemedIcon from "@/components/util/ThemedIcon";

import Vue from "vue";
import { setTimeout } from "timers";

export default {
  name: "MessagerieProfileBox",
  components: { ConnectedIcon, Photo, Pseudo, ThemedIcon },
  extends: BaseProfileBox,
  props: {
    result: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selected: false,
      scrollableList: null,
      unreadNotLoaded: false,
      typing: false,
      intervalId: null,
      deleteMode: false,
      subMenu: false
    };
  },

  computed: {
    messagerieComponent: function() {
      return this.$parent.$parent;
    },

    listeMessages: function() {
      return this.messagerieComponent.$refs.listeMessages;
    },

    unread: function() {
      if (this.result.unread) return true;
      return this.unreadNotLoaded;
    },

    receivedLetter: function() {
      return "/assets/images/pass.png";
    },

    lastGroup: function() {
      if (this.scrollableList.result.list.lengt === 0) return null;
      else {
        const index = this.scrollableList.result.list.length - 1;
        return this.scrollableList.result.list[index];
      }
    }
  },

  methods: {
    clicked: function() {
      this.$emit("click", this);
    },

    down: function() {
      setTimeout(() => {
        this.deleteMode = true;
      }, 1000);
    },

    markAsRead: async function() {
      if (this.unread && this.listeMessages.canRead) {
        await idyuJsonRpc("markAsRead", this.result.profile.id);
        this.result.unread = false;
        this.unreadNotLoaded = false;
        const index = this.$counters.unreadMessages.indexOf(this.result.profile.id);
        if (index !== -1) this.$counters.unreadMessages.splice(index, 1);
      } else {
        if (this.$store.state.user.knows != true) {
          await idyuJsonRpc("setKnows", true);
        }
      }
    },

    selectResult: async function() {
      this.selected = true;
      if (!this.scrollableList) {
        this.scrollableList = new ScrollableList(this.loadMessagesFromApi);
        this.scrollableList.reverse = true;
      }
      this.listeMessages.scrollableList = this.scrollableList;
      this.listeMessages.profile = this.result.profile;
      this.listeMessages.loading = true;
      await Vue.nextTick();
      await this.scrollableList.loadUntilScroll(this.listeMessages.$refs.listContainer);
      await this.markAsRead();
      this.listeMessages.loading = false;
      this.setEllapsedTime();
      if (this.intervalId == null) {
        this.intervalId = setInterval(() => {
          this.setEllapsedTime();
        }, 60000);
      }
      this.listeMessages.scrollDownMessages();
    },

    insertMessage: function(msg) {
      const newGroup = {
        date: msg.date,
        from: msg.from,
        list: [],
        ellapsed: ellapsed(msg.date)
      };
      this.scrollableList.result.list.push(newGroup);
      this.lastGroup.list.push(msg);
      if (this.selected) this.listeMessages.scrollDownMessages();
    },

    receiveMessage: async function(msg) {
      if (!this.scrollableList) this.unreadNotLoaded = true;
      else {
        this.insertMessage(msg);
        this.result.unread = true;
      }

      if (
        document.hidden === false &&
        this.selected &&
        this.$route.name === "Messagerie" &&
        (this.messagerieComponent.mobileMode === false || this.messagerieComponent.messageView === true)
      )
        await this.markAsRead();
      else if (this.$counters.unreadMessages.includes(msg.from.id) === false)
        this.$counters.unreadMessages.push(msg.from.id);
    },

    receivedRead: function() {
      const thisObj = this;

      this.scrollableList.result.list.forEach(group => {
        group.list.forEach(msg => {
          if (msg.from.id === thisObj.$store.state.profile.id) {
            msg.read = true;
          }
        });
      });
    },

    regroupList: function(list) {
      const groupedList = [];
      let last = null;
      let currentGroup = null;

      list.forEach(elt => {
        if (!last || idyuFormatDate(last.date) !== idyuFormatDate(elt.date) || last.from.id !== elt.from.id) {
          currentGroup = {
            list: [],
            from: elt.from,
            date: elt.date
          };

          groupedList.push(currentGroup);
        }

        currentGroup.list.splice(0, 0, elt);
        last = elt;
      });
      return groupedList;
    },

    setEllapsedTime() {
      for (let group of this.scrollableList.result.list) {
        group.ellapsed = ellapsed(group.date);
      }
    },

    loadMessagesFromApi: async function(list) {
      const newList = await idyuJsonRpc("getChatHistory", this.result.profile.id, 50, list.result.currentPage, false);
      const groupedList = this.regroupList(newList);

      const result = {
        results: groupedList,
        totalSize: 0
      };

      return result;
    },

    deleteClicked: async function(e) {
      this.closeSubMenu(e);
      if (
        await confirm(
          "Etes-vous sûr(e) de vouloir supprimer votre conversation avec " + this.result.profile.pseudo + " ?"
        )
      ) {
        idyuJsonRpc("deleteAllMessages", this.result.profile.id);

        this.remove();
      }
    },

    warn: async function(e) {
      this.closeSubMenu(e);
      if (
        await confirm("Souhaitez-vous signaler ce profil aux modérateurs Idylive pour un comportement inapproprié ?")
      ) {
        idyuJsonRpc("sendEmailToModerator", "Alerte modérateur", this.result.profile.pseudo);
        this.remove();
        history.pushState(null, null, "?");
        this.$emit("ban");
      }
    },

    block: async function(e) {
      this.closeSubMenu(e);
      if (await confirm("Souhaitez-vous bloquer ce profil ? Il ou elle ne pourra plus vous contacter sur Idylive")) {
        idyuJsonRpc("addBlacklistById", this.result.profile.id);
        this.remove();
        history.pushState(null, null, "?");
        this.$emit("ban");
      }
    },

    pointsClicked: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.subMenu = !this.subMenu;
    },

    remove: function() {
      const scrollableList = this.$parent.scrollableList;

      scrollableList.removeResult(this.result.profile.id);
      if (this.selected && scrollableList.result.list.length >= 1) {
        this.$parent.selectCorrespondant(null);
        this.scrollableList.result.list = [];
      }
    },

    closeSubMenu: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.subMenu = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.profileMembres {
  position: relative;
  display: grid;
  grid-template-columns: min-content 1fr auto;
  grid-gap: 10px;
  border-width: 1px;
  padding: 5px;
  cursor: pointer;
  align-items: center;

  &.selected,
  &.selected:hover {
    background: #b7dff8;
  }

  &:hover {
    background: #dae9f3;
  }

  .info {
    position: relative;
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    grid-gap: 5px;
  }

  .unread {
    height: 40px;
  }
}

.notif {
  font-style: italic;
  img {
    margin-right: 3px;
    vertical-align: -10%;
  }
}

.boutons {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  justify-items: left;
  grid-gap: 5px;
}

.fermer {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 24px;
  font-weight: bold;
}

.selected .fermer {
  display: block;
}

.menuPoints {
  position: absolute;
  display: grid;
  grid-gap: 5px;
  top: 0px;
  left: -300px;
  width: 280px;
  font-weight: normal;
  font-size: 16px;
  background-color: white;
  border: $light_border;
  box-shadow: $small_shadow;
  padding: 5px;
  z-index: 2000;
  overflow: visible;
  a:hover {
    color: $theme_color;
  }
  a {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    align-items: center;
  }

  img {
    height: 20px;
  }

  a:last-child {
    text-align: center;
    width: 100%;
    display: block;
    font-weight: bold;
    margin-top: 5px;
  }
}

@media screen and (max-width: $no_menuprogress) {
  .selected .fermer {
    display: none !important;
  }

  .deleteMode .fermer {
    display: block !important;
  }

  .profileMembres {
    &.selected {
      background-color: inherit;
    }
  }
}

.supprime {
  color: red;
  font-weight: bold;
}
</style>
<style>
.pseudoMessagerieProfileBox h3 {
  max-width: 210px;
}
</style>
